var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "raiseissue"
  }, [_c('b-card', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Raise Issue: Unable to attempt delivery")])])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("A shipment due for delivery on " + _vm._s(_vm.originaldate) + " was marked as 'Unable to attempt delivery' and\nre-scheduled for a future delivery date based on the instruction from the 'Consignee'.")]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("If you have not provided the instructions then raise an issue by selecting the relevant reason.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h6', [_c('b', [_vm._v("Please select a reason for raising the issue")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('label'), _vm._v(" "), _c('div', {
    staticClass: "radio resradio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reasonType),
      expression: "reasonType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('reasonType')
    },
    attrs: {
      "type": "radio",
      "id": "notcontacted",
      "value": "196",
      "name": "reasonType"
    },
    domProps: {
      "checked": _vm._q(_vm.reasonType, "196")
    },
    on: {
      "__c": function($event) {
        _vm.reasonType = "196"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "notcontacted"
    }
  }, [_vm._v("Was not contacted ")]), _c('br'), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reasonType),
      expression: "reasonType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('reasonType')
    },
    attrs: {
      "type": "radio",
      "id": "reschedule",
      "value": "197",
      "name": "reasonType"
    },
    domProps: {
      "checked": _vm._q(_vm.reasonType, "197")
    },
    on: {
      "__c": function($event) {
        _vm.reasonType = "197"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "reschedule"
    }
  }, [_vm._v("Contacted but did not ask to re-schedule")]), _c('br'), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reasonType),
      expression: "reasonType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('reasonType')
    },
    attrs: {
      "type": "radio",
      "id": "otherreason",
      "value": "198",
      "name": "reasonType"
    },
    domProps: {
      "checked": _vm._q(_vm.reasonType, "198")
    },
    on: {
      "__c": function($event) {
        _vm.reasonType = "198"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "otherreason"
    }
  }, [_vm._v("Any other reason")]), _vm._v(" "), _c('span', [_vm._v("(Please specify in the text box below)")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('reasonType')),
      expression: "errors.has('reasonType')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select Reason Type.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('label', [_vm._v("Please elaborate for other reason (50 characters)")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otherreason),
      expression: "otherreason"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "maxlength": "50",
      "name": "otherreason"
    },
    domProps: {
      "value": (_vm.otherreason)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.otherreason = $event.target.value
      }, function($event) {
        _vm.countFunction(_vm.otherreason)
      }]
    }
  })]), _vm._v(" "), (_vm.reasonType == 198 && _vm.otherreason.length == 0) ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please elaborate other reason.")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.otherreasonerr),
      expression: "otherreasonerr"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.otherreasonerr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('span', {
    staticClass: "irs-with-grid",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Available characters : " + _vm._s(_vm.reasonlength))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success resbutton",
    attrs: {
      "type": "submit",
      "disabled": _vm.disablesubmit == 1
    }
  }, [_vm._v("Submit")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', [_c('legend', [_vm._v("Customer care details")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-auto"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-phone",
    staticStyle: {
      "font-size": "15px",
      "margin-top": "4px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  +91 (020) 4911 6100")])]), _vm._v(" "), _c('div', {
    staticClass: "col-auto"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-envelope",
    staticStyle: {
      "font-size": "15px",
      "margin-top": "4px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  customercare@xpressbees.com")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('legend', [_vm._v("Shipment Details")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "shipomentdetails"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "33%"
    }
  }, [_vm._v("AWB :")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.awb))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Origin City :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.origincity))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Number of packages :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalmps))]), _vm._v(" "), _c('th', [_vm._v("Destination City :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.destinationcity))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Total Weight (kg) :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalwt))]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td')])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('legend', [_vm._v("Consignor Details")]), _vm._v(" "), _c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "consignor"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "33%"
    }
  }, [_vm._v("Consignor Name :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.consignorname))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Consignor Address :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.consignoraddress))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Consignor City :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.consignorcity))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Pincode :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.consignorpincode))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('legend', [_vm._v("Consignee Details")]), _vm._v(" "), _c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "consignee"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "33%"
    }
  }, [_vm._v("Consignee Name :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.consigneename))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Consignee Address :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.consigneeaddress))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Consignee City :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.consigneecity))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Pincode :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.consigneepincode))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "details"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "33%"
    }
  }, [_vm._v("Original delivery date :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.originaldate))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Re-scheduled delivery date :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rescheduledate))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Re-schedule reason :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.reason))])])])])])])])], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "xl"
    },
    on: {
      "ok": function($event) {
        _vm.showRaiseIssue = false
      }
    },
    model: {
      value: (_vm.showRaiseIssue),
      callback: function($$v) {
        _vm.showRaiseIssue = $$v
      },
      expression: "showRaiseIssue"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Raise Issue : Success")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeRaiseIssue
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Thanks,")]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("A service request has been created for this and will be resolved in"), _c('br'), _vm._v("stipulated time period.")]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("Please note the service request details below")]), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_c('b', [_vm._v("Service request number:")])]), _vm._v("  "), _c('span', [_vm._v(_vm._s(_vm.servicereqNo))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_c('b', [_vm._v("Shipment ID: ")])]), _vm._v("  "), _c('span', [_vm._v(_vm._s(_vm.awb))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_c('b', [_vm._v("Issue:")])]), _vm._v("  "), _vm._v("Fake UAD")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_c('b', [_vm._v("Reason:")])]), _vm._v("  "), _c('span', [_vm._v(_vm._s(_vm.raiseissuereason))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "-btn btn-success resbutton",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeRaiseIssue
    }
  }, [_vm._v("Close")])])])])])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4371dfb9","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/configuration/raiseissue/raiseissue.component.html
// module id = 1403
// module chunks = 3